export const checkCategoryDepthAndShowWarning = (
  depth: number,
  allowDepthArray: number[],
) => {
  if (!allowDepthArray.includes(depth)) {
    const allowListString = allowDepthArray.join(' or ')
    console.warn(`category.depth value is allow only ${allowListString}.`)
  }
}
